(function () {
  const style = document.createElement('style');

  style.textContent = `
    .product-card__quick-buy .button,
    .product-card__quick-buy button {
      transition: opacity 0.2s ease, transform 0.2s ease !important;
    }

    .product-card__quick-buy .button:hover,
    .product-card__quick-buy button:hover {
      opacity: 0.82;
      transform: translateY(-1px);
    }

    .product-card__mobile-quick-buy-button[aria-busy="true"] .button__loader {
      display: flex !important;
      opacity: 1 !important;
    }

    .product-card__mobile-quick-buy-button[aria-busy="true"] > div {
      opacity: 0 !important;
    }

    .product-card__mobile-quick-buy-button {
      position: relative !important;
    }

    .product-card__mobile-quick-buy-button .button__loader {
      position: absolute !important;
      top: 50% !important;
      left: 50% !important;
      transform: translate(-50%, -50%) !important;
      display: flex;
      gap: 3px;
      align-items: center;
    }

    .product-card__mobile-quick-buy-button .button__loader span {
      width: 4px !important;
      height: 4px !important;
      border-radius: 50% !important;
      background: currentColor !important;
      display: inline-block !important;
      animation: qb-dot-blink 0.6s ease-in-out infinite alternate !important;
    }

    .product-card__mobile-quick-buy-button .button__loader span:nth-child(2) {
      animation-delay: 0.2s !important;
    }

    .product-card__mobile-quick-buy-button .button__loader span:nth-child(3) {
      animation-delay: 0.4s !important;
    }

    .product-form .button[type="submit"],
    .product-form button[type="submit"],
    buy-buttons .button,
    buy-buttons button[type="submit"] {
      transition: opacity 0.2s ease, transform 0.2s ease !important;
    }

    .product-form .button[type="submit"]:hover,
    .product-form button[type="submit"]:hover,
    buy-buttons .button:hover,
    buy-buttons button[type="submit"]:hover {
      opacity: 0.82;
      transform: translateY(-1px);
    }

    @keyframes qb-dot-blink {
      from {
        opacity: 1;
        transform: scale(1);
      }

      to {
        opacity: 0.2;
        transform: scale(0.7);
      }
    }
  `;

  document.head.appendChild(style);

  document.addEventListener(
    'click',
    function (event) {
      const button = event.target.closest(
        '.product-card__quick-buy .button, .product-card__mobile-quick-buy-button'
      );

      if (!button) {
        return;
      }

      button.setAttribute('aria-busy', 'true');

      let attempts = 0;

      const poll = window.setInterval(function () {
        attempts += 1;

        const openDrawer = document.querySelector(
          'quick-buy-drawer[open]'
        );

        const pageLeaving = document.hidden;

        if (openDrawer || pageLeaving || attempts > 120) {
          window.clearInterval(poll);
          button.removeAttribute('aria-busy');
        }
      }, 50);
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      const button = event.target.closest(
        'product-form button[type="submit"], buy-buttons button[type="submit"]'
      );

      if (
        !button ||
        button.closest('.product-card__quick-buy')
      ) {
        return;
      }

      button.setAttribute('aria-busy', 'true');

      function onDone() {
        button.removeAttribute('aria-busy');

        document.removeEventListener(
          'cart:change',
          onDone
        );

        document.removeEventListener(
          'cart:error',
          onDone
        );
      }

      document.addEventListener(
        'cart:change',
        onDone
      );

      document.addEventListener(
        'cart:error',
        onDone
      );

      window.setTimeout(onDone, 8000);
    },
    true
  );
})();